import { openBlock as t, createElementBlock as e, createStaticVNode as a } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ a('<path fill="#6DA544" d="M0 20c0 8.6 5.428 15.93 13.043 18.756L14.783 20l-1.74-18.756C5.428 4.07 0 11.401 0 20Z"></path><path fill="#D80027" d="M40 20C40 8.954 31.045 0 20 0c-2.447 0-4.79.44-6.957 1.244v37.512A19.955 19.955 0 0 0 20 40c11.045 0 20-8.954 20-20Z"></path><path fill="#FFDA44" d="M13.043 26.956a6.957 6.957 0 1 0 0-13.913 6.957 6.957 0 0 0 0 13.913Z"></path><path fill="#D80027" d="M9.13 16.522v4.348a3.913 3.913 0 1 0 7.826 0v-4.348H9.13Z"></path><path fill="#F0F0F0" d="M13.043 22.174a1.306 1.306 0 0 1-1.304-1.304v-1.74h2.609v1.74c0 .719-.585 1.304-1.305 1.304Z"></path>', 5), c = [
  o
];
function h(p, n) {
  return t(), e("svg", l, [...c]);
}
const r = { render: h };
export {
  r as default,
  h as render
};
